import React from 'react';
import Modal from '../../../modals/modal';
import SnapRecordModal from '../../../modals/snapRecordModal';
import DeleteModal from '../../../modals/deleteModal';
import Commentmodal from '../../../modals/commentModal';
import InsertGifModal from '../../../modals/insertGifModal';
import UserModal from '../../../modals/userModal';
import { buildMessageUploadFolder, isMediaRecordingSupported, isEmpty } from '../../../../helpers/common';
import { CommentFilesInterface } from '../../../../interfaces/TaskInterface';
import { CHAT_GROUP_TYPE } from '../../../../global/constants';
import { TiptapEditorRef } from '../../../../interfaces/tiptapInterface';
import { ChatGroupInterface } from '../../../../interfaces/chatMessageInterface';
import { ProjectModel } from '../../../../mobx/models/project';
import { getIsEveryoneMentionEnable } from '../../../../helpers/mentionHelper';

interface MessageModalsProps {
  // Snap Recording Modal
  isSnapModalOpen: boolean;
  handleCloseSnapModal: () => void;

  // Delete Message Modal
  deletedMessageId: string | null;
  closeDeleteMessageModal: () => void;
  deleteMessage: () => Promise<void>;
  deleteLoading: boolean;

  // Edit Message Modal
  isOpenEditMessageModal: boolean;
  Cancel: () => void;
  inlineRef: React.RefObject<TiptapEditorRef>;
  onSendComment: (files: CommentFilesInterface[], isEdit?: boolean) => Promise<void>;
  uploadedFiles: CommentFilesInterface[];
  setUploadedFiles: (
    files: CommentFilesInterface[] | ((prevFiles: CommentFilesInterface[]) => CommentFilesInterface[])
  ) => void;
  content: string;
  setValueContent: (value: string) => void;
  loading: boolean;
  setPropsLoading: (value: boolean) => void;
  currentProject: ProjectModel | ChatGroupInterface | null;
  isNavbarMessage: boolean;
  attachmentPage: (isCommentModal: boolean) => void;
  handleOpenSnapModal: () => void;
  editingMessage: boolean;

  // GIF Modal
  openGifModal: boolean;
  handleCloseGifModal: () => void;

  // User Modal
  isOpenUserModal: boolean;
  onCloseUserModal: () => void;
}

const MessageModals: React.FC<MessageModalsProps> = ({
  isSnapModalOpen,
  handleCloseSnapModal,
  deletedMessageId,
  closeDeleteMessageModal,
  deleteMessage,
  deleteLoading,
  isOpenEditMessageModal,
  Cancel,
  inlineRef,
  onSendComment,
  uploadedFiles,
  setUploadedFiles,
  content,
  setValueContent,
  loading,
  setPropsLoading,
  currentProject,
  isNavbarMessage,
  attachmentPage,
  handleOpenSnapModal,
  editingMessage,
  openGifModal,
  handleCloseGifModal,
  isOpenUserModal,
  onCloseUserModal
}) => {
  const editModalUsers = (currentProject?.users || []).filter((user) => !isEmpty(user?.id));
  const isEveryoneMentionEnable = getIsEveryoneMentionEnable(currentProject, isNavbarMessage);
  const uploadFolder = buildMessageUploadFolder(currentProject?.id);

  return (
    <>
      {isMediaRecordingSupported() && (
        <Modal open={isSnapModalOpen} onClose={handleCloseSnapModal} maxWidth={'258px'}>
          <SnapRecordModal handleCloseModal={handleCloseSnapModal} />
        </Modal>
      )}
      <Modal open={!!deletedMessageId} onClose={closeDeleteMessageModal} maxWidth={'334px'}>
        <DeleteModal
          onClose={closeDeleteMessageModal}
          onOk={deleteMessage}
          loading={deleteLoading}
          modalTitle={`Delete message?`}
          description={'Are you sure you want to delete this message?'}
        />
      </Modal>
      <Modal open={isOpenEditMessageModal} onClose={Cancel} maxWidth={'692px'} isResponsiveMaxWidth={true}>
        <Commentmodal
          headerText='Update message'
          ref={inlineRef}
          onClose={Cancel}
          sendComment={(files: CommentFilesInterface[]) => onSendComment(files, editingMessage)}
          users={editModalUsers}
          isEveryoneMentionEnable={isEveryoneMentionEnable}
          excludeCurrentUser={true}
          uploadedFiles={uploadedFiles}
          setUploadedFiles={setUploadedFiles}
          valueContent={content}
          setValueContent={setValueContent}
          propsLoading={loading}
          setPropsLoading={setPropsLoading}
          onClickSelectFile={
            (currentProject as ChatGroupInterface)?.type === CHAT_GROUP_TYPE.PROJECT || !isNavbarMessage
              ? () => attachmentPage(true)
              : undefined
          }
          handleOpenSnapModal={handleOpenSnapModal}
          disable={false}
          isEditMessage={true}
          uploadFolder={uploadFolder}
        />
      </Modal>

      <Modal open={openGifModal} onClose={handleCloseGifModal} maxWidth={'686px'} isResponsiveMaxWidth={true}>
        <InsertGifModal
          setSelectedGif={(url: string) => {
            inlineRef.current?.addImageInContent(url);
          }}
          closeModal={handleCloseGifModal}
        />
      </Modal>
      <Modal open={isOpenUserModal} onClose={onCloseUserModal} maxWidth={'280px'}>
        <UserModal onClose={onCloseUserModal} />
      </Modal>
    </>
  );
};

export default React.memo(MessageModals);
